import ReactDOM from 'react-dom/client';
import './index.css';
import './configs/dayjs';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from 'react-error-boundary';
import { AppErrorMessage } from './components/common/AppErrorMessage';
import { markTestEnvironment } from './utils/markTestEnvironment';
import { markStaleChunkErrors } from './utils/staleChunk';

markTestEnvironment();
markStaleChunkErrors();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// register the service worker (enables push notifications and offline capabilities)
navigator.serviceWorker.register('/serviceWorker.js').catch((error) => {
  console.error('Service worker registration failed:', error);
});

const logError = (thrown: unknown) => {
  const error =
    thrown instanceof Error
      ? { message: thrown.message, stack: thrown.stack, name: thrown.name }
      : { message: String(thrown) };
  console.error(JSON.stringify({ severity: 'ERROR', error }));
};

root.render(
  <ErrorBoundary fallback={<AppErrorMessage />} onError={logError}>
    <App />
  </ErrorBoundary>
);

reportWebVitals();
